export enum FormModes {
    Add = "add",
    Edit = "edit",
    View = "view"
}
